"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollToFirstErrorOnSubmit = void 0;
var _formik = require("formik");
var _react = require("react");
const getErrorPaths = function (errors) {
  let path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!errors) {
    return [];
  }
  if (typeof errors === "string" || Array.isArray(errors)) {
    return [path];
  }
  return Object.keys(errors).flatMap(key =>
  // @ts-ignore
  getErrorPaths(errors[key], [...path, key]));
};
const useScrollToFirstErrorOnSubmit = ref => {
  const {
    errors,
    isValid,
    isSubmitting
  } = (0, _formik.useFormikContext)();
  (0, _react.useEffect)(() => {
    if (!isValid && isSubmitting && ref.current) {
      const flattenedErrorSelector = getErrorPaths(errors).map(path => "[name=\"".concat(path.join("."), "\"]")).join(", ");
      // Select the first descendant of the ref that has the same field name as
      // any of the errors.
      const firstErrorField = ref.current.querySelector(flattenedErrorSelector);
      if (firstErrorField) {
        firstErrorField.scrollIntoView();
      }
    }
  }, [isValid, isSubmitting, errors, ref]);
};
exports.useScrollToFirstErrorOnSubmit = useScrollToFirstErrorOnSubmit;
//# sourceMappingURL=useScrollToFirstErrorOnSubmit.js.map